import "./prize-to-win.scss";
// import {Categories} from "../../data-access/store/game/types/socket-events/category";
// import { useAppSelector } from "../../../hooks/hooks";
// import {
//   selectLanguage,
//   selectTranslations,
// } from "../../data-access/store/general/generalSlice";
// import { useGetPrizesQuery } from "../../../prizes/data-access/store/services/prizes.service";
// import { checkTranslationKey } from "../../../utils/translation";

interface PrizeToWinProps {
  auth?: boolean;
}

export function PrizeToWin({ auth = true }: PrizeToWinProps) {
  // const { data: prizesData } = useGetPrizesQuery();
  // const lang = useAppSelector(selectLanguage);
  // const translations = useAppSelector(selectTranslations);
  //
  // const grandPrize = prizesData?.items?.find((prize) => prize.position === 1);

  return (
    <div id="prizes">
      {/*{grandPrize && (*/}
      {/*  <div className="prize">*/}
      {/*    <div className="prize-image">*/}
      {/*      <img src={grandPrize.image} alt="" />*/}
      {/*    </div>*/}
      {/*    <div className="prize-name">{grandPrize.name[lang]}</div>*/}
      {/*  </div>*/}
      {/*)}*/}
      {/*<div className="prize-title">*/}
      {/*  {checkTranslationKey(translations[lang]?.Prizes, "Prizes")}*/}
      {/*  <div className="small-title">*/}
      {/*    {checkTranslationKey(translations[lang]?.to_win, "to win!")}*/}
      {/*  </div>*/}
      {/*</div>*/}
      <div className="prize">
        <div className="prize-image">
          {auth ? (
            <img src="../img/prize/prizes-to-win.png" alt="" />
          ) : (
            <img src="../img/prize/prizes-to-win-non-auth.png" alt="" />
          )}
        </div>
        {/*<div className="prize-name">*/}
        {/*  {checkTranslationKey(translations[lang]?.Strike_win, "Strike+Win")}*/}
        {/*</div>*/}
      </div>
    </div>
  );
}
